module.exports = __webpack_public_path__ + "static/images/prev_disable.0645278.png";